module.exports = __webpack_public_path__ + "static/media/funchal-5.ab83db87.svg";